module.exports = __webpack_public_path__ + "img/F.8be954c5.jpg";